export default "__VITE_ASSET__C4GDmU99__"